module.exports = __webpack_public_path__ + "static/media/meade-farm-group.f9ad0478.jpg";